import styled, { css } from 'styled-components';
import { customMedia } from 'styles/utils';

import Icon from 'components/Icon';
import Button from 'components/Button';

const TRIANGLE_SIZE = 4;

export const NavCubeStyled = styled.nav`
  pointer-events: auto;
  width: ${props => props.width}px;
  right: ${props => (props.right ? props.right : 0)}px;
  top: ${props => props.top}px;
  position: absolute;
  background-color: ${props => props.theme.color.wfWhite};
  border-left: 1px solid ${props => props.theme.color.wfGrey200};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  border-top: 1px solid ${props => props.theme.color.wfGrey200};
  display: ${props => (props.visible ? 'flex' : 'none')};
  z-index: 10;
  flex-direction: row;
  /* transition: transform 1s ease; */
  transform: translateX(${props => `-${props.right}` || '0px'});

  /* Pseudoelement to creating a box for include the nav canvas cube */
  &::before {
    content: '';
    border-left: 1px solid ${props => props.theme.color.wfGrey200};
    position: absolute;
    right: 0px;
    height: ${props => props.height}px;
    top: ${props => -props.height}px;
    width: ${props => props.width}px;
    pointer-events: none;
  }

  ${customMedia.lessThan('medium')`
    display: none;
  `};
`;

export const ButtonStyled = styled(Button)`
  width: 50%;
  padding: ${props =>
    `${props.theme.spacing.xsmall} ${props.theme.spacing.default}`};
  color: ${props => props.theme.color.wfBlack};
  position: relative;
  ${props =>
    props.hasDropdown &&
    css`
      &::after {
        content: '';
        width: 0;
        height: 0;
        border: ${TRIANGLE_SIZE}px solid transparent;
        border-top: ${TRIANGLE_SIZE}px solid #000;
        position: absolute;
        bottom: 0;
        right: 1%;
        transform: rotate(-45deg);
      }
    `}
  & + & {
    border-left: 1px solid ${props => props.theme.color.wfGrey200};
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PCEtLSBHZW5lcmF0b3I6IEdyYXZpdC5pbyAtLT48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHN0eWxlPSJpc29sYXRpb246aXNvbGF0ZSIgdmlld0JveD0iMCAwIDQwIDQwIiB3aWR0aD0iNDBwdCIgaGVpZ2h0PSI0MHB0Ij48ZGVmcz48Y2xpcFBhdGggaWQ9Il9jbGlwUGF0aF9abDRjRVBCQnNwTE5EVU5MTml5UkNkbjZKTmxGVVVrVSI+PHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xpcC1wYXRoPSJ1cmwoI19jbGlwUGF0aF9abDRjRVBCQnNwTE5EVU5MTml5UkNkbjZKTmxGVVVrVSkiPjxwYXRoIGQ9IiBNIDMxLjg5NSAzNi4xODUgTCAyNi45MjcgMzYuMTg1IEwgMjYuOTI3IDM5IEwgMzYuNjI1IDM5IEwgMzYuNjI1IDI5LjE0OCBMIDMzLjg1NCAyOS4xNDggTCAzMy44NTQgMzQuMTk1IEwgMjEuMzg1IDIxLjUyNyBMIDE5Ljk5OSAyMi41NDcgTCAxOS45OTkgMjQuMTAxIEwgMzEuODk1IDM2LjE4NSBaICBNIDguMTA1IDM2LjE4NSBMIDEzLjA3MyAzNi4xODUgTCAxMy4wNzMgMzkgTCAzLjM3NSAzOSBMIDMuMzc1IDI5LjE0OCBMIDYuMTQ2IDI5LjE0OCBMIDYuMTQ2IDM0LjE5NSBMIDE4LjYxNSAyMS41MjcgTCAxOS45OTkgMjIuNTQ3IEwgMTkuOTk5IDI0LjEwMSBMIDguMTA1IDM2LjE4NSBaICBNIDE4LjYxMyAxMi4yNiBMIDE4LjYxMyAyMS41MjcgTCAxOS45OTkgMjIuNTQ3IEwgMjEuMzg1IDIxLjUyNyBMIDIxLjM4NSAxMi4yNiBMIDIxLjM4NSA2LjYyOSBMIDIxLjM4NSA2LjM4NyBMIDI0Ljk2NyAxMC4wMjYgTCAyNi45MjcgOC4wMzYgTCAxOS45OTkgMSBMIDEzLjA3MyA4LjAzNiBMIDE1LjAzMSAxMC4wMjYgTCAxOC42MTMgNi4zODcgTCAxOC42MTMgNi42MjkgTCAxOC42MTMgMTIuMjYgWiAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0icmdiKDIwNSwyMDUsMjA1KSIvPjwvZz48L3N2Zz4=);
    background-repeat: no-repeat;
    background-size: 1.1em;
    background-position: center;
  }
  &:hover {
    background-color: ${props => props.theme.color.wfGrey200};
  }
`;

export const NavCubeExpandStyled = styled.article`
  position: absolute;
  width: calc(100% + 1px);
  right: 0;
  top: 100%;
  color: ${props => props.theme.color.wfGrey900};
  background-color: ${props => `${props.theme.color.wfWhite}AA`};
  border: 1px solid ${props => props.theme.color.wfGrey200};
  padding: ${props =>
    `0 ${props.theme.spacing.xsmall} ${props.theme.spacing.xsmall}`};
`;

export const NodeStyled = styled.dl`
  font-size: 0.9rem;
  &:not(:first-of-type) {
    margin-top: ${props => props.theme.spacing.xsmall};
  }
`;

export const NodeTitle = styled.dt`
  line-height: ${props => props.theme.font.size.default};
  color: ${props => props.theme.color.wfWhite};
  background-color: ${props => `${props.theme.color.wfBlack}EE`};
  margin: ${props => `0 -${props.theme.spacing.xsmall} 0`};
  padding: 2px 6px;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  border-top: ${props =>
    !props.isFirst && `1px solid ${props.theme.color.wfGrey200}`};
`;

export const ActionNodeStyled = styled.dd`
  color: ${props =>
    !props.active
      ? props.theme.color.wfGrey500
      : props.selected
      ? props.theme.color.wfBlue
      : props.theme.color.wfBlack};
  text-decoration: ${props => props.selected && 'underline'};
  padding-left: ${props => props.theme.spacing.xsmall};
  margin-top: 0;
  &:hover {
    text-decoration: underline;
    cursor: ${props => (props.active ? 'pointer' : 'default')};
  }
  display: ${props => props.stacked && 'inline-flex;'};
  width: ${props =>
    props.stacked && props.stacked === 2
      ? 'calc(50%)'
      : props.stacked === 3
      ? 'calc(33%)'
      : ''};
`;

export const IconStyled = styled(Icon)`
  margin-right: ${props => props.theme.spacing.small};
  vertical-align: bottom;
`;
